import {Component, HostListener, Injector} from '@angular/core';
import {Platform} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';

import {HomePage} from '../pages/home/home';
import {DataProvider} from "../providers/dataprovider/dataprovider";
import {CalendarProvider} from "../providers/calendar/calendar";
import {BackgroundMode} from "@ionic-native/background-mode";
import {HttpClient} from "@angular/common/http";
import {Http} from "@angular/http";
import {LoginProvider} from "../providers/login/login.provider";
import {LoginPage} from "../pages/login/login";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any;

  @HostListener('window:beforeunload', ['$event'])
  public beforeunloadHandler($event) {
    console.log('before window close');
  }

  constructor(platform: Platform,
              statusBar: StatusBar,
              splashScreen: SplashScreen,
              private injector: Injector,
              private calendarProvider: CalendarProvider,
              private backgroundMode: BackgroundMode,
              private loginProvider: LoginProvider) {

            platform.ready().then(() => {
              // this.injector.get(DataProvider);
              this.backgroundMode.enable();
              this.calendarProvider.createCalendarIfNotExists();
              // Okay, so the platform is ready and our plugins are available.
              // Here you can do any higher level native things you might need.
              localStorage.setItem('started', 'true');
              statusBar.styleDefault();
              splashScreen.hide();
              this.rootPage = HomePage;

            });

      // })
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts